import { useTranslation } from 'react-i18next'

export const useReadableLayoutNames = (): Record<string, string> => {
  const { t } = useTranslation()

  return {
    normal: t('leafletMap_options_layoutStandard_label'),
    grey: t('leafletMap_options_layoutPale_label'),
    normalNight: t('leafletMap_options_layoutNightMode_label'),
    satellite: t('leafletMap_options_layoutSatellite_label'),
    osm: t('leafletMap_options_layoutOSM_label'),
  }
}
